// Copyright (c) 2017 Deere & Company

const emptyArrayLength = 0;

export const filterProductHierarchy = (textToSearch, productHierarchy) =>
    productHierarchy ?
        productHierarchy.reduce((newLevel, currentLevel) => {

            if (currentLevel.description.match(textToSearch)) {

                newLevel.push(currentLevel);

            } else {

                const nextLevel = filterProductHierarchy(textToSearch, currentLevel.productHierarchy);

                if (nextLevel && nextLevel.length > emptyArrayLength) {

                    newLevel.push({
                        ...currentLevel,
                        productHierarchy: nextLevel
                    });

                }

            }

            return newLevel;

        }, []) :
        null;



// WEBPACK FOOTER //
// ./src/shared/components/facets/product-hierarchy/helpers.js